import BaseRoutes from '../routing/base-routes.es6';

class StockCheckerRoutes extends BaseRoutes {
    constructor(options) {
        super(options)
        Object.assign(this, {baseUrl: '/stockchecker', nav: 9}, options);

        this.states['stockcheck'] = {
            nav: this.nav,
            icon: 'product-hunt',
            title: 'Stock Checker',
            url: (this.isRoot() ?  null : this.baseUrl),
            controller($state, $stateParams) {
                console.info("BL*** current state name = " + $state.current.name);
                if($state.current.name == 'stockcheck'){
                    $state.transitionTo("stockcheck.welcome", $stateParams);
                }
            },
            templateProvider: ($stateParams) => '<stock-checker/>' // <ui-view/>
        };
        this.states['stockcheck.welcome'] = {
            url: '/welcome',
            templateProvider: ($stateParams) => `<stock-checker-welcome/>`
        };
        this.states['stockcheck.search'] = {
            url: '/search',
            templateProvider: ($stateParams) => `<stock-checker-search/>`
        };
        this.states['stockcheck.product'] = {
            url: '/product/{productId:[^/]+}',
            templateProvider: ($stateParams) => `<stock-checker-product product-id="${$stateParams.productId}"/>`
        };

    }
}

export default StockCheckerRoutes;